export const SECONDARY = "rgba(138, 73, 212, 0.2)";
export const _SECONDARY = "rgba(121, 121, 121, 0.1)";

export const LIGHTEST_GREY = "#AFAFAF";
export const SECONDARY_GRAY = "#cccccc";
export const LIGHT_GREY = "#999999";
export const GREY = "#666666";
export const DARK_GREY = "#333333";

export const LIGHT_BRAND = "#CDA7F9";
export const BRAND = "#946cc1";
export const DARKER_BRAND = "#7C4BB4";
export const DARK_BRAND = "#572096";

export const LIGHT_RED = "#F87C93";
export const DARKER_RED = "#C82D4A";
export const DARK_RED = "#A12038";

export const WHITE = "white";

const COLORS = {
  colors_background: WHITE,
  colors_black: "rgba(0, 0, 0, 0.1)",
  colors_black_2: "rgba(0, 0, 0, 0.25)",
  colors_black_3: "rgba(49, 49, 49, 0.3)",
  colors_black_4: "black",
  colors_blue: "blue",
  colors_brand: BRAND,
  colors_custom_input_border: "hsl(0, 0%, 80%)",
  colors_darker_brand: DARKER_BRAND,
  colors_darker_grey: "#424242",
  colors_error: "#cc0000",
  colors_success: "green",
  colors_warning: "yellow",
  colors_grey: "grey",
  colors_grey_2: GREY,
  colors_label_Gray: "rgb(121 121 121)",
  colors_secondary_gray: SECONDARY_GRAY,
  colors_border: "rgba(121, 121, 121, 0.6)",
  colors_pronunciation_select_border: "rgba(49, 49, 49, 0.3)",
  colors_secondary: SECONDARY,
  colors_white: WHITE,
  colors_dark_grey: DARK_GREY,
  colors_light_grey: LIGHT_GREY,
  colors_red: "#C82D4A",
  colors_purple: "#6B419B",
  redesign_colors_error_input_background: "#FFF2F2",
  redesign_colors_error_input_message: "#A12038",
};

export const AVATAR_PLACEHOLDER_COLORS = {
  purple: "#7C4BB4",
  blue: "#1976D2",
  red: "#C82D4A",
  orange: "#E53935",
  azure: "#2DBFC8",
  green: "#8DC82D",
};

export const BUTTON_COLORS = {
  default: GREY,
  defaultFocused: DARK_GREY,
  defaultDisabled: LIGHTEST_GREY,

  primary: DARKER_BRAND,
  primaryFocused: DARK_BRAND,
  primaryDisabled: LIGHT_BRAND,

  danger: DARKER_RED,
  dangerFocused: DARK_RED,
  dangerDisabled: LIGHT_RED,
}

export default COLORS;
